import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';

import './Care.scss';

const Care = () => {
  return (
    <section className="care">
      <Container extraClassName="care__wrapper">
        {[
          {
            title: <>Возьмём на&nbsp;себя заботы о&nbsp;ремонте</>,
            description: (
              <>
                Если нужно, закупим и&nbsp;доставим материалы, организуем
                строй-тех надзор, сделаем уборку
              </>
            ),
          },
          {
            title: <>Бригады работают строго по&nbsp;техкартам</>,
            description: (
              <>
                Это стандарты, инструкции и&nbsp;правила, гарантирующие качество
                на&nbsp;каждом этапе ремонта
              </>
            ),
          },
          {
            title: (
              <>95% отзывов о&nbsp;нас выше 8&nbsp;из&nbsp;10&nbsp;баллов</>
            ),
            description: (
              <>
                Мы&nbsp;дорожим своей репутацией и&nbsp;гордимся высокими
                оценками наших клиентов
              </>
            ),
          },
        ].map((item, index) => (
          <div className="care__card" key={index}>
            <div className="care__card_top">
              <div className={`care__card-icon care__card-icon_${index + 1}`} />

              <Title
                extraClassName="care__card-title"
                level={TitleLevel.H3}
                size={TitleSize.H3}
              >
                {item.title}
              </Title>
            </div>

            <p className="care__card-description">{item.description}</p>
          </div>
        ))}
      </Container>
    </section>
  );
};

export default Care;
